import loadable from '@loadable/component';

const Input = loadable(() => import('/views/partials/forms/input'));
const Form = loadable(() => import('/views/partials/forms/form'));
const FormFeedback = loadable(() => import('/views/partials/forms/form-feedback'));
const PinInput = loadable(() => import('/views/partials/forms/pin-input'));

export { Input, Form, FormFeedback, PinInput };
